
// @ts-nocheck
import locale_en_46json_993f4628 from "#nuxt-i18n/993f4628";
import locale_es_46json_e8445a62 from "#nuxt-i18n/e8445a62";

export const localeCodes =  [
  "en",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_993f4628",
      load: () => Promise.resolve(locale_en_46json_993f4628),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_e8445a62",
      load: () => Promise.resolve(locale_es_46json_e8445a62),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      language: "en",
      label: "EN",
      files: [
        {
          path: "/codebuild/output/src1723499913/src/own-your-mindset-map/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      iso: "es-MX",
      language: "es",
      label: "ES",
      files: [
        {
          path: "/codebuild/output/src1723499913/src/own-your-mindset-map/locales/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "../locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    language: "en",
    label: "EN",
    files: [
      {
        path: "/codebuild/output/src1723499913/src/own-your-mindset-map/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es-MX",
    language: "es",
    label: "ES",
    files: [
      {
        path: "/codebuild/output/src1723499913/src/own-your-mindset-map/locales/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/